import { Dispatch } from "react";

import {
  setCoAError,
  setCoALoading,
  setProductCoADetails,
  setCoABatchesListing,
} from "./slice";
import {
  showAlert,
  isAPISuccessful,
  checkInternetAndShowAlert,
} from "../../../common/utils";
import { RootState } from "../../../redux/store";
import { setLoading } from "../../../redux/global.slice";
import { EndPoint, Module } from "../../../common/constants";
import { $axios } from "../../../common/constants/axios.instance";

export const getCoAChainDetail =
  (coaId: string, callback?: (data: any) => void) =>
  async (dispatch: Dispatch<any>) => {
    if (!checkInternetAndShowAlert(showAlert)) return;

    dispatch(setCoALoading(true));

    try {
      const response = await $axios.get(
        `${Module.consumer}${EndPoint.PRODUCT_COA_CHAIN}`,
        {
          params: { coaId },
        },
      );
      const { data } = response;

      if (isAPISuccessful(data.statusCode)) {
        const result = data?.data;
        dispatch(setProductCoADetails(result));
        if (callback) callback(result);
      }

      dispatch(setCoALoading(false));
    } catch (err: any) {
      dispatch(setCoAError(err?.message || "Something went wrong"));
      showAlert(2, err?.message);
      dispatch(setCoALoading(false));
    }
  };

export const getCoARecentBatchesListing =
  (strainMongoId: string, callback?: (data: any) => void) =>
  async (dispatch: Dispatch<any>, getState: () => RootState) => {
    if (!checkInternetAndShowAlert(showAlert)) return;

    dispatch(setLoading(true));

    try {
      const response = await $axios.get(
        `${Module.consumer}${EndPoint.STRAIN_RECENT_BATCHES}`,
        {
          params: { strainMongoId },
        },
      );
      const { data } = response;

      if (isAPISuccessful(data.statusCode)) {
        const result = data?.data;
        dispatch(setCoABatchesListing(result));
        callback && callback(result);
      }

      dispatch(setLoading(false));
    } catch (err: any) {
      dispatch(setLoading(false));
      showAlert(2, err?.message || "Something went wrong");
    }
  };
